import OpenAIIcon from '@/components/icons/aiModels/openai-icon';
import IconSailboat from '@/components/icons/aiModels/sailboat-icon';
import { ChatIcon } from '@/components/icons/chat-icon';
import {
  TriangleIcon,
  Brain,
  AsteriskIcon,
  SparkleIcon,
  ShellIcon,
  WindIcon,
  SquarePlayIcon,
  SquareSigma,
  ImagesIcon,
  PaletteIcon,
  ImageIcon,
  VideoIcon,
} from 'lucide-react';

type Props = {
  iconList: any;
  iconName: string;
  type_id?: string;
  [key: string]: unknown;
};

export const getIcon = ({ iconList, iconName, type_id, ...rest }: Props) => {
  const TagName = iconList[iconName] || (type_id && iconList[type_id]);
  return !!TagName ? <TagName {...rest} /> : null;
};

const aiIconList: any = {
  midjourney: IconSailboat,
  gpt: OpenAIIcon,
  dalle: OpenAIIcon,
  'flux-ai': TriangleIcon,
  lora: Brain,
  claude: AsteriskIcon,
  gemini: SparkleIcon,
  'hailuo-ai': ShellIcon,
  ideogram: WindIcon,
  'kling-ai': SquarePlayIcon,
  'leonardo-ai': ImagesIcon,
  llama: () => <span className="px-1">🦙</span>,
  mistral: ChatIcon,
  sora: OpenAIIcon,
  'stable-diffusion': PaletteIcon,
  '1': ImageIcon,
  '2': ChatIcon,
  '3': ChatIcon,
  '4': VideoIcon,
};

type AIModelProps = {
  iconName: string;
  type_id?: string;
  [key: string]: unknown;
};

export const getAIModelIcon = ({
  iconName,
  type_id,
  ...rest
}: AIModelProps) => {
  const AIModelName = aiIconList[iconName] || (type_id && aiIconList[type_id]);
  return !!AIModelName ? <AIModelName {...rest} /> : null;
};
